// Interfaces
import { ITableBodyRequestAttrs } from 'interfaces/table'

// Lodash
import pick from 'lodash/pick'
import isEmpty from 'lodash/isEmpty'

/**
 * @description Handle any change inside table
 *
 * @param {string} name
 * @param {any} value
 *
 * @return {ITableBodyRequestAttrs} ITableBodyRequestAttrs
 */
export const tableUtils_handleTableChange = (table: ITableBodyRequestAttrs, name: string, value: any): ITableBodyRequestAttrs => {
  // Check if change come from base table
  let sorter: any
  if (name === 'table') sorter = pick(value, ['sorter'])?.sorter

  let filter = {
    ...table,
    sortDirection: sorter?.order === 'descend' ? true : sorter?.order === 'ascend' ? false : table.sortDirection,
    sortColumn: !isEmpty(sorter?.column) ? sorter?.column?.key : name === 'table' ? sorter?.column?.key : table.sortColumn || '',
    pageNumber: name !== 'pageNumber' ? 1 : value,
    searchKeyword: name === 'searchKeyword' ? value : table.searchKeyword,
  }

  if (name !== 'table') {
    filter = {
      ...filter,
      [name]: value,
    }
  }

  if (!filter?.sortColumn) {
    return {
      ...filter,
      sortColumn: '',
    }
  } else {
    return filter
  }
}
